<!--
    Paging is off, but the table still cuts its rows to one page, so the page
    is sized to the visible rows. No caption (search), footer or selection
    column, and no header unless the consumer gives one: the default header
    is click-to-sort, which would reorder the flattened rows.
-->
<app-table
    [value]="visibleRows()"
    [columns]="columns()"
    [tableClassStyle]="tableClasses()"
    [showHeader]="headerTemplate() != null"
    [showCaption]="false"
    [showFooter]="false"
    [paginator]="false"
    [selectable]="false"
    [rowsPerPageModel]="visibleRows().length || 1">

    <ng-template appTemplate="theadTemplate" let-columns>
        <ng-container *ngTemplateOutlet="headerTemplate(); context: { $implicit: columns }" />
    </ng-template>

    <ng-template appTemplate="tbodyTemplate" let-rowNode let-columns="visibleColumns">
        <ng-container *ngTemplateOutlet="bodyTemplate(); context: { $implicit: rowNode, rowData: rowNode.data, columns }" />
    </ng-template>
</app-table>
